<template>
    <div id="parentDiv" style="width:970px;height: 668px;background: #red;display:block;">
        <Spin size="large" fix v-if="isloadingshow"></Spin>
        <div v-if="ishow">
            <div class="leftdiv">
                <img src="../../assets/images/confirm_bgleft1.png" style="height: 668px;" />
                <div class="leftdesc">
                {{modalType===1?'请您选择购买时长':(modalType===2?'请您选择续费时长':'正在为您升级产品')}}
                </div>
            </div>
            <div class="rightdiv">
                <div class="topdiv">
                    <div class="innerleftdiv">
                        <!-- <Icon type="md-contact" size="40" color="#2d8cf0" class="icon" /> -->
                        <img src="../../assets/images/img/user_unlogin.png" class="icon" />
                    </div>
                    <div class="innerrightdiv">
                        <div class="rowtext">
                            <p class="p1">账号：{{sta.userId}}</p>
                            <p v-if="currentPurchaseData" class="p2">{{modalType===1?'购买':(modalType===2?'续费':'升级到')}}{{currentPurchaseData.name}}</p>
                        </div>
                    </div>
                </div>
                <div v-if="this.modalType===3" class="xupgrade">
                    <List :header="'升级的版本信息：从'+upgradeinfo.oriproductname+'升级到'+upgradeinfo.upproductname" border>
                        <ListItem>原订单剩余天数：{{upgradeinfo.daysremainint}}天</ListItem>
                        <ListItem>原订单结算余额：{{upgradeinfo.balance}}元</ListItem>
                        <ListItem>需要支付的差额：{{upgradeinfo.spread}}元</ListItem>
                    </List>
                </div>
                <div v-else class="xgrid">
                    <p class="xgrid_desc">购买时长</p>
                    <p class="grid_row">
                        <div class="parent">
                            <div class="row">
                                <div v-for="item in cardOptions" :class="item.selected?'column1':'column'" @click="itemselect(item)">
                                    <div style="height: 35px;">
                                        <div v-show="item.selected">
                                            <span class="checkbg">
                                            </span>
                                            <Icon class="checkicon" type="md-checkmark" color="white" />
                                        </div>
                                    </div>
                                    <div :class="item.selected?'p_select':'p_default'">
                                        <div class="p_year">{{item.salenumber}}{{currentPurchaseData.billingtype===1?'年':'天'}}</div>
                                        <div class="p_price"><span class="symbol">¥</span>{{item.newprice}}</div>
                                        <div class="p_original">
                                            <span v-if="item.oriprice!==item.newprice" style="font-size: 14px;display:block;height: 20px;">¥{{item.oriprice}}</span>
                                            <span v-else style="font-size: 14px;display:block;height: 20px;"></span>
                                        </div>
                                        <div class="p_desc">
                                            <span style="font-size: 14px;">{{item.discountdesc}}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </p>
                </div>
                <div class="payment">
                    <p class="payment_desc">支付方式</p>
                    <div class="pay-change" style="text-align: left;margin-left: 10px;margin-top:20px;">
                        <RadioGroup type="button" v-model="payChange">
                            <Radio label="微信" border>
                                <i size=26  class="iconfont" style="color: #19c105;font-size: 22px;">&#xe665;</i>
                                <span style="color: #2D2F33;font-size: 16px;position: relative;top:-2px;left:4px;">微信支付</span>
                                <img style="position: relative;left:16px;top:9px;" src="../../assets/images/img/wx_checked.png" />
                            </Radio>
                         <!--    <Radio label="支付宝" border>
                    <i class="iconfont" style="color: #00aaee;">&#xe618;</i>
                    <span style="color: #00aaee;">支付宝</span>
                </Radio> -->
                        </RadioGroup>
                    </div>
                </div>
                <div class="billinfo">
                    <p class="billinfo_desc">发票信息</p>
                    <div class="invoiceContent">
                        <span v-if="invoiceType===1">普通发票</span>
                        <span v-else-if="invoiceType===2">增值税专用发票</span>
                        <span style="padding-left:5px;">{{invoiceHeaderName}}</span>
                        <Button type="text" style="box-shadow:none;text-decoration:underline;color:#19be6b;" @click="showInvoice">修改</Button>
                    </div>
                </div>
                <div v-if="modalType===1" class="couponrow">
                    <p class="couponrow_desc">优惠信息</p>
                    <NewCoupon ref="mycoupon" @on-check="onCouponChecked" :isAgentShow="true" :isCouponShow="isSetCouponShow" />
                </div>
                <div v-else class="couponrow">
                </div>
                <div class="totalrow">
                    <span class="span1">实际支付：<span class="span2">{{productNewPrice}}元</span></span>
                    <Button type="primary" style="background:#FF5326;vertical-align: middle;margin-right:20px;border:none;" @click="order">去支付</Button>
                </div>
            </div>
        </div>
        <div v-else style="display:table;margin:0 auto;width:970px;height: 458px;">
            <div style="display:table-cell; vertical-align:middle;text-align: center;">
                <div style="display: block;">
                    <Icon type="md-alert" size="120" color="#ff9900" />
                </div>
                <div style="display: block;margin-top: 50px;font-size: 16px;">
                    {{warningmsg}}
                </div>
            </div>
        </div>
        <Modal v-model="modalInvoice" width="700" :styles="{top: '15px'}" :mask-closable="false">
            <p slot="header" style="color:#2b85e4;text-align:center;font-size:16px;">
                <Icon type="ios-information-circle"></Icon>
                <span>修改发票信息</span>
            </p>
            <div>
                <Invoice ref='myInvoice' :isModal="true" />
            </div>
            <div slot="footer">
                <Button type="text" size="large" @click="cancelInvoice">取消</Button>
                <Button type="primary" size="large" @click="getInvoiceInfo">确定</Button>
            </div>
        </Modal>
        <QR ref="QRPayModal" @paySuccess="payComplete" @showAgreement="showPackageAgreement" />
        <Agreement ref="product_agreement" :isConfirm="true" @onAccept="onAgreementAccept" />
    </div>
</template>
<script>
import invoice from "./myinvoice.vue"
import newcoupon from './newcoupon.vue'
import qrModal from './qrpay.vue'
import ProductAgreement from './new_product_agreement.vue'
import { mapGetters } from 'vuex'
import ConstJson from '../../api/common/constjson'
import store from "../../store/"
let constJ = new ConstJson()
export default {
    data() {
        return {
            isSetCouponShow: false,
            isloadingshow: false,
            ishow: true,
            warningmsg: '载入中,请稍后',
            modalType: 1,
            cardOptions: [],
            currentDiscountData: null,
            currentPurchaseData: null,
            promocode: {
                couponcode: '',
                agentcode: '',
            },
            copydata: '',
            memberLevelChkInfo: null,
            newprice: 0, //折后价
            oriprice: 0, //原价
            sonheadertype: 1,
            myInvoiceHeader: {
                bankaccount: "",
                bankname: "",
                headercode: "",
                headername: "个人",
                headertype: 1,
                invoiceTotal: 0,
                mobilenumber: "",
                officeaddress: "",
                postaddress: '',
                postemail: '',
                postmobile: '',
            },
            invoiceHeaderName: '个人',
            invoiceType: 1,
            modalInvoice: false,
            payChange: '微信',
            upgradeinfo: {},


        }
    },
    components: {
        "Invoice": invoice,
        'NewCoupon': newcoupon,
        'QR': qrModal,
        'Agreement': ProductAgreement,
    },
    created() {
        if (this.checkUserLogin()) {
            //this.getProductsV2()
        }
    },
    computed: {
        ...mapGetters(['sta']),
        //会员包原价
        productOriginalTotal: function() {
            let p = this.oriprice //this.formData.price * this.formData.orderYears * 365
            return p
        },
        productNewPrice: function() {
            let p = 0
            if (this.modalType === 3) {
                p = this.upgradeinfo.spread
            } else {
                p = this.newprice
            }

            return p
        },
    },
    methods: {
        // show(pdata, cOption) {
        //       console.log('products show===>')
        //       console.log(pdata, cOption)
        //       this.currentPurchaseData = pdata
        //       this.cardOptions = cOption
        //       //this.modalPurchase1 = true

        //       this.cardOptions[0].selected = true
        //       this.newprice = this.cardOptions[0].newprice
        //       this.oriprice = this.cardOptions[0].oriprice
        //       this.currentDiscountData = this.cardOptions[0]

        //       this.$refs.myInvoice.getInvoice()
        //       //清空coupon信息
        //       this.$refs.mycoupon.clean()
        //   },

        //检查是否已经存在代理商编码，存在则自动绑定并且不能修改
        //如果用户存在已绑定的代理商编码则自动绑定，且不能修改，20210429
        checkUserAgentIsExist() {
            constJ.getUserAgentInfo().then(res => {
                console.log('检查是否已经存在代理商编码==>')
                console.log(res)
                if (res.rltcode === 1 && res.rtncode === 1) {
                    if (res.item && res.item.fromagent !== '') {
                        let agent = res.item
                        this.$refs.mycoupon.setDefaultAgent(agent)
                    }
                }
            }).catch(function(e) {
                console.log(e)
                return
            })
        },

        order() {
            if (this.modalType === 1) {
                this.takeOrder()
            } else if (this.modalType === 2) {
                this.renewOrder()
            } else if (this.modalType === 3) {
                this.takeUpgradeOrder()
            }
        },

        //续费下单
        renewOrder() {
            //如果验证码错误则清空提交的数据
            // if (this.$refs.mycoupon) {
            //     let r = this.$refs.mycoupon.getConfirmInfo()
            //     console.log(r)
            // }
            // console.log(this.$refs.mycoupon.getConfirmInfo())
            console.log(this.currentPurchaseData)
            let product = this.currentPurchaseData
            let discountData = this.currentDiscountData

            // this.promocode.couponcode = this.$refs.mycoupon.formCustom.couponValue
            // this.promocode.agentcode = this.$refs.mycoupon.formCustom.agencies

            //console.log(product, discountData)
            let _invoice = {
                invoicetype: this.invoiceType,
                invoiceheader: this.myInvoiceHeader
            }
            let poData = {
                product: product.code,
                discount: discountData.discountcode,
                paytype: 30,
                couponcode: '',
                agentcode: '',
                invoice: _invoice,

            }
            constJ.reqRenewOrder(poData).then(res => {
                console.log(res)
                if (res.rltcode === 1 && res.rtncode === 1) {
                    this.base64str = `data:image/png;base64,` + res.result.strdata
                    this.orderid = res.result.orderid
                    let finalprice = res.result.actualAmount
                    let da = {
                        base64str: this.base64str,
                        orderid: this.orderid,
                        payChange: this.payChange,
                        totalBill: finalprice, //this.productNewPrice
                    }
                    console.log('po============>')
                    console.log(da)
                    this.$refs.QRPayModal.show(da)
                    this.getOrderContract(this.orderid)
                } else {

                    this.$Message.warning('下单异常,请稍后重试')

                    // return
                }
            }).catch(err => {
                console.log(err)
                this.$Message.warning(err)
                // return
            })
        },
        //购买下单
        takeOrder() {
            if (this.$refs.mycoupon) {
                let r = this.$refs.mycoupon.getConfirmInfo()
                console.log(r)
            }
            console.log(this.currentPurchaseData)
            let product = this.currentPurchaseData
            let discountData = this.currentDiscountData
            this.promocode.couponcode = this.$refs.mycoupon.formCustom.couponValue
            this.promocode.agentcode = this.$refs.mycoupon.formCustom.agencies
            //console.log(product, discountData)
            let _invoice = {
                invoicetype: this.invoiceType,
                invoiceheader: this.myInvoiceHeader
            }
            let poData = {
                product: product.code,
                discount: discountData.discountcode,
                paytype: 30,
                couponcode: this.promocode.couponcode,
                agentcode: this.promocode.agentcode,
                invoice: _invoice,

            }
            //用户等级包下单
            constJ.reqCreateOrder(poData).then(res => {
                console.log(res)
                if (res.rltcode === 1 && res.rtncode === 1) {
                    //绑定支付二维码
                    this.base64str = `data:image/png;base64,` + res.result.strdata
                    this.orderid = res.result.orderid
                    this.totalBill = res.result.actualAmount
                    let da = {
                        base64str: this.base64str,
                        orderid: this.orderid,
                        payChange: this.payChange,
                        totalBill: this.totalBill,
                    }
                    console.log('po============>')
                    console.log(da)
                    this.$refs.QRPayModal.show(da)
                    this.getOrderContract(this.orderid)

                } else {
                    //更新产品列表,当前产品已购买
                    this.$Message.warning(res.rltdesc)
                    //console.log('您已购买过此产品')
                    return
                }
            })
        },
        //计算产品升级信息
        getProductUpgradeInfo(product) {
            console.log(this.currentPurchaseData)
            this.currentPurchaseData = product
            let poData = {
                upproductcode: product.code,
            }
            //获取产品升级信息
            constJ.reqCountUpgradeData(poData).then(res => {
                console.log(res)
                this.isloadingshow = false
                if (res.rltcode === 1 && res.rtncode === 1) {
                    this.upgradeinfo = res.result
                    //读取发票信息
                    this.$refs.myInvoice.getInvoice()
                } else {
                    // if (res.rltcode === -1033) {
                    //     this.ishow = false
                    //     this.warningmsg = res.rltdesc
                    // }
                    this.ishow = false
                    this.warningmsg = res.rltdesc
                    this.$Message.warning(res.rltdesc)
                    return
                }
            })
        },
        //确认升级并下单支付
        takeUpgradeOrder() {
            //console.log(this.currentPurchaseData)
            //let product = this.currentPurchaseData
            let _invoice = {
                invoicetype: this.invoiceType,
                invoiceheader: this.myInvoiceHeader
            }
            let poData = {
                upproductcode: this.currentPurchaseData.code,
                paytype: 30,
                invoice: _invoice,
            }
            //获取产品升级信息
            constJ.reqProductUpgrade(poData).then(res => {
                console.log(res)
                if (res.rltcode === 1 && res.rtncode === 1) {
                    this.base64str = `data:image/png;base64,` + res.result.strdata
                    this.orderid = res.result.orderid
                    let finalprice = res.result.actualAmount
                    let da = {
                        base64str: this.base64str,
                        orderid: this.orderid,
                        payChange: this.payChange,
                        totalBill: finalprice, //this.productNewPrice
                    }
                    console.log('po upgrade============>')
                    console.log(da)
                    this.$refs.QRPayModal.show(da)
                    this.getOrderContract(this.orderid)
                } else {
                    this.$Message.warning(res.rltdesc)
                    return
                }
            })
        },
        //获取合同信息
        getOrderContract(orderid) {
            //獲取合同信息
            console.log('获取升级包合同orderid:' + orderid)
            constJ.reqGetOrderContract(orderid).then(res => {
                console.log(res)
                if (res.rltcode === 1 && res.rtncode === 1) {
                    //this.showQRAndCheckPayStatus()
                    this.$refs.product_agreement.createdata(res.item)
                }
            })
        },
        onAgreementAccept() {
            console.log("onAgreementAccept======>")
        },
        showPackageAgreement() {
            this.$refs.product_agreement.show()
        },
        payComplete() {
            console.log('支付完成===>')
            this.$emit('payComplete')
        },
        getProductYearList(item) {
            console.log(item)
            //按后端配置显示优惠码
            this.isSetCouponShow = item.showcoupon
            let current_product = null
            let pkg = JSON.stringify(item)
            current_product = JSON.parse(pkg)
            this.currentPurchaseData = current_product
            let code = item.code
            constJ.reqProductDiscountList(code).then(res => {
                console.log(res)
                this.isloadingshow = false
                if (res.rltcode === 1 && res.rtncode === 1) {

                    this.cardOptions = res.item
                    if (!this.cardOptions) {
                        this.$Message.warning('无产品优惠信息！')
                        return
                    }

                    this.cardOptions[0].selected = true
                    this.newprice = this.cardOptions[0].newprice
                    this.oriprice = this.cardOptions[0].oriprice
                    this.currentDiscountData = this.cardOptions[0]

                    //拷贝设置原始价格
                    let _copy = {
                        oriprice: this.newprice
                    }
                    this.copydata = JSON.stringify(_copy)

                    //读取发票信息
                    this.$refs.myInvoice.getInvoice()

                    //检查用户是否已经绑定过代理商
                    this.checkUserAgentIsExist()

                    //购买
                    //this.$refs.mymemberlevel.show(this.currentPurchaseData, this.cardOptions)
                    //this.modalPurchase = true
                    //读取发票信息
                    //this.$refs.myInvoice.getInvoice()
                    //this.$refs.myInvoice.invoiceTotal=this.totalBill
                }
            })

        },
        //购买
        show(product, t) {
            console.log(product)
            //清空coupon信息
            this.isloadingshow = true
            this.ishow = true
            this.$nextTick(() => {
                this.modalType = t
                if (this.modalType === 3) {
                    //升级产品
                    this.getProductUpgradeInfo(product)
                } else {
                    //购买或续费
                    if (this.$refs.mycoupon) {
                        this.$refs.mycoupon.clean()
                    }
                    this.getProductYearList(product)
                }
            })


        },
        showCouponPrice(value) {
            this.newprice = value.item.amount
            this.oriprice = value.item.oriamount
            console.log(value)
        },
        onCouponChecked(chkinfo) {
            this.memberLevelChkInfo = chkinfo
            if (chkinfo.isChecked) {
                this.$refs.mycoupon.countPromocode(this.newprice, this.showCouponPrice)
            } else {
                this.$refs.mycoupon.clean()
                //还原到原始价格
                //console.log(this.copydata)
                let _copy = JSON.parse(this.copydata)
                this.newprice = _copy.oriprice
                //this.loadDefaultPackages(this.rowData)
            }
        },
        getInvoiceInfo() {
            console.log("this.productNewPrice:" + this.productNewPrice)
            this.$refs.myInvoice.$refs.formData.validate((valid) => {
                if (valid) {
                    if (this.$refs.myInvoice.formData.headertype == 1) {
                        this.$refs.myInvoice.formData.headercode = ''
                        this.$refs.myInvoice.formData.officeaddress = ''
                        this.$refs.myInvoice.formData.mobilenumber = ''
                        this.$refs.myInvoice.formData.bankname = ''
                        this.$refs.myInvoice.formData.bankaccount = ''
                        // this.$refs.myInvoice.formData.postaddress = ''
                        // this.$refs.myInvoice.formData.postemail = ''
                        // this.$refs.myInvoice.formData.postmobile = ''
                    }
                    this.sonheadertype = Number(this.$refs.myInvoice.formData.headertype)
                    console.log(this.sonheadertype);
                    this.$refs.myInvoice.remData = JSON.parse(JSON.stringify(this.$refs.myInvoice.formData))
                    this.$refs.myInvoice.remheadertype = this.$refs.myInvoice.formData.headertype
                    let _invoiceType = this.$refs.myInvoice.invoicetype
                    let invoiceHeader = { ...this.$refs.myInvoice.formData }
                    this.invoiceHeaderName = this.$refs.myInvoice.formData.headertype == 1 ? '个人' : '单位'
                    this.invoiceType = Number(_invoiceType)
                    this.myInvoiceHeader = invoiceHeader
                    this.myInvoiceHeader.headertype = Number(invoiceHeader.headertype)
                    this.modalInvoice = false
                    console.log(this.invoiceType, invoiceHeader, this.invoiceHeaderName)
                } else {
                    this.$Message.error('请填写必填项！');
                    return
                }
            })

        },
        cancelInvoice() {
            this.modalInvoice = false
        },
        showInvoice() {
            console.log('显示发票===>')
            this.modalInvoice = true
            this.$refs.myInvoice.invoiceTotal = this.productNewPrice
            //this.$refs.myInvoice.invoicetype = '1'
            //this.$refs.myInvoice.getInvoice()
        },
        itemselect(rowitem) {
            this.cardOptions.forEach(function(item) {
                item.selected = false
            })
            const findelement = this.cardOptions.find(element => element.discountcode === rowitem.discountcode)
            findelement.selected = true

            // let _index = this.productDiscount.findIndex(element => element.discountcode === id)
            // this.$set(this.productDiscount, _index, findelement)


            console.log(findelement)
            this.newprice = findelement.newprice
            this.oriprice = findelement.oriprice
            this.currentDiscountData = findelement

            //拷贝切换到的原始价格
            let _copy = {
                oriprice: this.newprice
            }
            this.copydata = JSON.stringify(_copy)


            //切换账号等级年限
            if (this.memberLevelChkInfo && this.memberLevelChkInfo.isChecked) {
                this.$refs.mycoupon.countPromocode(this.productNewPrice, this.showCouponPrice)
            }

        },
        checkUserLogin() {
            let value = this.sta.userId
            if (value && value.length > 0) {
                return true
            } else {
                return false
            }
        },
    },
}
</script>
<style lang="less" scoped>
// @font-face {
//     font-family: 'iconfont';
//     /* project id 1804652 */
//     src: url('//at.alicdn.com/t/font_1804652_306rskp3iol.eot');
//     src: url('//at.alicdn.com/t/font_1804652_306rskp3iol.eot?#iefix') format('embedded-opentype'),
//         url('//at.alicdn.com/t/font_1804652_306rskp3iol.woff2') format('woff2'),
//         url('//at.alicdn.com/t/font_1804652_306rskp3iol.woff') format('woff'),
//         url('//at.alicdn.com/t/font_1804652_306rskp3iol.ttf') format('truetype'),
//         url('//at.alicdn.com/t/font_1804652_306rskp3iol.svg#iconfont') format('svg');
// }

@font-face {
  font-family: 'iconfont';  /* project id 2108466 */
  src: url('//at.alicdn.com/t/font_2108466_t6fdrccd8ut.eot');
  src: url('//at.alicdn.com/t/font_2108466_t6fdrccd8ut.eot?#iefix') format('embedded-opentype'),
  url('//at.alicdn.com/t/font_2108466_t6fdrccd8ut.woff2') format('woff2'),
  url('//at.alicdn.com/t/font_2108466_t6fdrccd8ut.woff') format('woff'),
  url('//at.alicdn.com/t/font_2108466_t6fdrccd8ut.ttf') format('truetype'),
  url('//at.alicdn.com/t/font_2108466_t6fdrccd8ut.svg#iconfont') format('svg');
}


.iconfont {
    //font-size: 16px;
    font-family: 'iconfont';
    //margin-right: 10px;
}


#parentDiv {
    //radio button style
    /deep/.ivu-radio-border{
        height: 40px;
        line-height: 40px;
        background:#F4FFF9;
    }
    .ivu-radio-wrapper-checked.ivu-radio-border{
        border-color:#19be6b;
    }
    /deep/.ivu-radio-inner{
        top:-3px;
        left:-5px;
    }
    /deep/.ivu-radio-inner:after{
         background-color:#29CC6D;
    }
    //end radio button style


    //left box
    .leftdiv {
        display: inline-block;
        width: 304px;
        height: 658px;
        background: #2D8CF0;
        border-radius: 6px 0px 0px 6px;
        vertical-align: top;

        img {
            margin-bottom: 0px;
        }

        .leftdesc {
            position: absolute;
            top: 200px;
            width: 226px;
            height: 25px;
            text-align: center;
            //font-weight: bold;
            font-size: 26px;
            color: #fff;
            margin: 0px 25px 0px 48px;
        }
    }

    //right box
    .rightdiv {
        vertical-align: top;
        width: 666px;
        height: 658px;
        display: inline-block;
        border-radius: 0px 6px 6px 0px;

        //account info
        .topdiv {
            // width: 670px;
            margin-top: 10px;
            height: 54px;
            border-radius: 0px 6px 0px 0px;
            //background-color: lightblue;

            .innerleftdiv {
                vertical-align: top;
                height: 54px;
                display: inline-block;
                width: 60px;

                .icon {
                    width: 40px;
                    height: 40px;
                    position: relative;
                    left: 60%;
                    top: 46%;
                    transform: translate(-50%, -50%);
                }
            }

            .innerrightdiv {
                vertical-align: top;
                height: 54px;
                display: inline-block;
                //width: 570px;

                .rowtext {
                    position: relative;
                    left: 60%;
                    top: 50%;
                    transform: translate(-50%, -50%);

                    .p1 {
                        font-size: 14px;
                        font-weight: 400;
                        color: #2B2F33;
                    }

                    .p2 {

                        font-size: 14px;
                        font-weight: 400;
                        color: #878E99;
                    }
                }
            }
        }

        .xupgrade {
            margin: 10px;
            display: block;
            width: 650px;
            height: 230px;
            //background-color: lightgreen;
        }

        .xgrid {
            margin: 10px;
            display: block;
            width: 650px;
            height: 230px;
            //background-color: lightgreen;

            .xgrid_desc {
                width: 64px;
                margin-left: 10px;
                height: 16px;
                font-size: 16px;
                font-weight: bold;
                color: #2D2F33;
            }

            .grid_row {}
        }

        .payment {
            display: block;
            width: 650px;
            height: 70px;
            margin: 10px;

            .payment_desc {
                width: 64px;
                margin-left: 10px;
                height: 16px;
                font-size: 16px;
                font-weight: bold;
                color: #2D2F33;
            }

            //background-color: yellow;
        }

        .billinfo {
            display: block;
            width: 660px;
            height: 50px;
            margin: 10px;

            //background-color: blue;
            .billinfo_desc {
                width: 64px;
                margin-left: 10px;
                height: 16px;
                font-size: 16px;
                font-weight: bold;
                color: #2D2F33;
            }

            /*发票信息*/
            .invoiceContent {
                margin-top: 10px;
                text-align: left;
                margin-right: 12px;

                span {
                    padding-left: 10px;
                }
            }
        }

        .couponrow {
            display: block;
            width: 660px;
            height: 164px;
            margin: 10px;
            // background:gray;
            //background-color: orange;
            .couponrow_desc {
                width: 64px;
                margin-left: 10px;
                margin-bottom: 5px;
                height: 16px;
                font-size: 16px;
                font-weight: bold;
                color: #2D2F33;
            }
        }

        .totalrow {
            position:relative;
            top:-15px;
            right: 5px;
            display: block;
            width: 680px;
            height: 40px;
            line-height: 20px;
            margin: 10px;
            text-align: right;
            // background-color: yellow;
            .span1 {
                margin-right: 22px;
                vertical-align: middle;
                font-size: 14px;
                font-weight: 400;
                color: #2D2F33;
                font-family: Source Han Sans CN;
            }

            .span2 {
                font-size: 30px;
                font-weight: 400;
                color:#FF5326;
            }

            //background-color:darkblue;
        }
    }

    //宫格
    .parent {
        position: absolute;
        display: flex;
        flex-direction: column;
        width: 650px;
        height: 180px;
        margin-top: 20px;
        background: #fff;
    }

    .row {
        flex: 1;
        display: flex;
    }

    .row+.row {
        margin-top: 10px;
    }

    .column {
        background: #fff;
        flex: 1;
        display: block;
        border-radius: 6px;
        margin-left: 10px;
        border: 2px solid #D1D9E6;
        position: relative;
        overflow: hidden;
        cursor: pointer;
    }

    // .column+.column {
    //     margin-left: 10px;
    // }

    .column1 {
        background: #FFF7F5;
        flex: 1;
        display: block;
        border-radius: 6px;
        margin-left: 10px;
        border: 2px solid #FF5326;
        position: relative;
        overflow: hidden;
        cursor: pointer;
    }

    // .column1+.column1 {
    //     margin-left: 10px;
    // }

    //check background
    .checkbg {
        display: block;
        background-color: #FF5326;
        height: 50px;
        width: 50px;
        position: absolute;
        float: right;
        top: -25px;
        right: -25px;
        transform: translate(50px, 50px);
        -webkit-transform: rotate(45deg);
    }

    //right icon
    .checkicon {
        height: 22px;
        width: 20px;
        position: absolute;
        float: right;
        top: 3px;
        right: 0px;
    }

    //产品信息默认
    .p_default {
        color: #878E99;

        .p_year {
            font-size: 20px;
            font-weight: bold;
            text-align: center;
        }

        .p_price {
            font-size: 36px;
            font-weight: bold;
            line-height: 40px;
            height: 40px;
            margin-top: 10px;
            text-align: center;
            display: block;

            .symbol {
                font-size: 16px;
                vertical-align: top;
                margin-right: 5px;
                font-weight: 400;
                position: relative;
                top: -10px;
            }
        }

        .p_original {
            font-size: 14px;
            font-weight: 400;
            line-height: 24px;
            margin-top: 10px;
            text-align: center;
            text-decoration: line-through;
        }

        .p_desc {
            font-size: 14px;
            font-weight: 400;
            line-height: 24px;
            margin-top: 20px;
            text-align: center;
        }
    }

    //产品信息选中
    .p_select {
        color: #FF5326;

        .p_year {
            color: #17233D;
            font-size: 20px;
            font-weight: bold;
            text-align: center;
        }

        .p_price {
            font-size: 36px;
            font-weight: bold;
            line-height: 40px;
            height: 40px;
            margin-top: 10px;
            text-align: center;
            display: block;

            .symbol {
                font-size: 16px;
                vertical-align: top;
                margin-right: 5px;
                font-weight: 400;
                position: relative;
                top: -10px;
            }
        }

        .p_original {
            font-size: 14px;
            font-weight: 400;
            line-height: 24px;
            margin-top: 10px;
            text-align: center;
            text-decoration: line-through;
        }

        .p_desc {
            font-size: 14px;
            font-weight: 400;
            line-height: 24px;
            margin-top: 20px;
            text-align: center;
        }
    }




}
</style>